import { PROFILE_VIEW, All_INTERESTS, USER_INTERESTS, USER_SUBINTERESTS } from '../actions/actionTypes';

let user = localStorage.getItem('userDetails');
const initialState =  {ownProfile:false};

export default function profile(state = initialState, action) {
    switch (action.type) {
        case PROFILE_VIEW:
            return {
                ...state,
                ownProfile: action.ownProfile,
              
            };
        case All_INTERESTS:
            return {
                ...state,
                interests: action.interests,
                
            };
        case USER_INTERESTS:
            return {
                ...state,
                userInterests: action.userInterests,
                
            };
        case USER_SUBINTERESTS:
            return {
                ...state,
                userSubInterests: action.userSubInterests,
                
            };
        default:
            return state
    }
}
